import React from 'react';

export const IconClose = () => (
  <svg viewBox="0 0 12 12">
    <path
      d="M11.1046 10.0379C11.4094 10.3427 11.4094 10.7998 11.1046 11.1046C10.9522 11.257 10.7998 11.3332 10.5713 11.3332C10.3427 11.3332 10.1903 11.257 10.0379 11.1046L5.99984 7.0665L1.96174 11.1046C1.80936 11.257 1.65698 11.3332 1.42841 11.3332C1.19984 11.3332 1.04746 11.257 0.895075 11.1046C0.590313 10.7998 0.590313 10.3427 0.895075 10.0379L4.93317 5.99984L0.895075 1.96174C0.590313 1.65698 0.590313 1.19984 0.895075 0.895075C1.19984 0.590313 1.65698 0.590313 1.96174 0.895075L5.99984 4.93317L10.0379 0.895075C10.3427 0.590313 10.7998 0.590313 11.1046 0.895075C11.4094 1.19984 11.4094 1.65698 11.1046 1.96174L7.0665 5.99984L11.1046 10.0379Z"
      fill="currentColor"
    />
  </svg>
);
